import {
  hotspotIcon,
  generateCustomIconXml,
  returnProcessedContent
} from '~js/helpers'

import { isRtl } from '../../../../i18n/i18n-helper'
import { componentGalleryXml } from './component-gallery'
const getMarkerTagXml = function (marker, ath, atv, useCustomIcon, index, markerScale, krpanoVrModeObj) {
  const objectId = marker.objectId
  let tag = ''
  const title = returnProcessedContent(marker.name)
  const price = returnProcessedContent(marker.price)
  const description = returnProcessedContent(marker.description)
  const rtl = isRtl()
  const imagesLength = marker.images.length
  const hasPrice = Boolean(marker.price)
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6

  if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    const inverserotation = (marker.coordinatePlane === 3)
    const rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    const rz = marker.rotation.z
    tag += `<hotspot
      name="marker_${objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ${generateCustomIconXml(marker)}
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      distorted="true"
      inverserotation="${inverserotation}"
      rx="${rx}"
      ry="${ry}"
      rz="${rz}"
      mipmapping="true"
      enabled="${!marker.disabled}"
      capture="false"
      onclick="
        set_marker_info(${index});
        marker_mousein(${objectId}, ${index});
        if (webvr.isenabled,
          close_webXR_marker(${opacity});
          ini_webXR_gallery_variable(${imagesLength});
          ini_webXR_common_variable(${objectId});
          set_webXR_marker_tag_scale_html(${title}, ${price}, ${description});
          set_webXR_marker_tag_position(${ath}, ${atv});
          set_webXR_marker_tag_size();
          set_webXR_marker_tag_offset(${rtl}, ${hasPrice});
          set_webXR_gallery_buttons_img();
          set_webXR_button_events(${opacity}, ${price});
        );
      "
      onover="marker_mousein(${objectId}, ${index});"
      onout="marker_mouseout(${objectId}, ${index}, null, ${opacity});" />`
  } else {
    tag += `<hotspot
      name="marker_${objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ${generateCustomIconXml(marker)}
      ath="${ath}"
      atv="${atv}"
      alpha="${opacity}"
      zorder="${marker.index}"
      enabled="${!marker.disabled}"
      capture="false"
      mipmapping="true"
      onclick="
        set_marker_info(${index});
        marker_mousein(${objectId}, ${index});
        if (webvr.isenabled,
          close_webXR_marker(${opacity});
          ini_webXR_gallery_variable(${imagesLength});
          ini_webXR_common_variable(${objectId});
          set_webXR_marker_tag_scale_html(${title}, ${price}, ${description});
          set_webXR_marker_tag_position(${ath}, ${atv});
          set_webXR_marker_tag_size();
          set_webXR_marker_tag_offset(${rtl}, ${hasPrice});
          set_webXR_gallery_buttons_img();
          set_webXR_button_events(${opacity}, ${price});
        );
      "
      onover="marker_mousein(${objectId}, ${index});"
      onout="marker_mouseout(${objectId}, ${index}, null, ${opacity});" />`
  }

  tag += `<hotspot
    name="markerInfo_${objectId}"
    style="markerInfo"
    scale="0"
    visible="false"
    width="0"
    height="0"
    ath="${ath}"
    atv="${atv - 4.5}"
    zorder="${marker.index}" />`

  tag += componentGalleryXml(
    marker,
    krpanoVrModeObj,
    `reopen_webXR_marker(${price});`
  )
  return tag
}

export default getMarkerTagXml
